import Vue from 'vue';
import App from './App';
import router from './router';
import './api/api.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store';
import {
  useAutoLogin
} from '@/assets/js/autoLogin.js'
Vue.prototype.$store = store;
import {
  Message
} from 'element-ui';
import {
  Loading
} from 'element-ui';
import {
  getToken
} from "@/assets/js/auth.js";
// 首页引导插件
import intro from 'intro.js' // introjs库
import 'intro.js/introjs.css' // introjs默认css样式
// introjs还提供了多种主题，可以通过以下方式引入
import 'intro.js/themes/introjs-modern.css' // introjs主题
// 把intro.js加入到vue的prototype中，方便使用，就可以直接通过this.$intro()来调用了
Vue.prototype.$intro = intro
import introConfig from "@/assets/js/introConfig.js";
Vue.prototype.$introConfig = introConfig
import PageNavHeader from '@/components/PageNavHeader.vue'
Vue.component('PageNavHeader', PageNavHeader)

// 注册全局自动登录功能
const { handleAutoLogin, waitForAutoLogin } = useAutoLogin(store);
Vue.prototype.$autoLogin = { handleAutoLogin, waitForAutoLogin };

Vue.prototype.openLoading = function() {
  const loading = this.$loading({ // 声明一个loading对象
    lock: true, // 是否锁屏
    text: '加载中', // 加载动画的文字
    spinner: 'el-icon-loading', // 引入的loading图标
    background: 'rgba(0, 0, 0, 0.8)', // 背景颜色
    target: '.el-table, .table-flex, .region', // **需要遮罩的区域，这里写要添加loading的选择器**
    fullscreen: false,
    customClass: 'loadingclass' // **遮罩层新增类名，如果需要修改loading的样式**
  })
  setTimeout(function() { // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
    loading.close(); // 关闭遮罩层
  }, 5000)
  return loading;
}

if (getToken('USER_Msg')) {
  var disableChange = JSON.parse(getToken('USER_Msg')).parent.is_nail;
  Vue.prototype.disableChange = disableChange;
}
//判断是移动端还是pc端
Vue.prototype.detectDevice = function() {
  const ua = navigator.userAgent;
  const width = window.innerWidth;

  // 优先根据屏幕宽度判断
  if (width < 576) return 'mobile';
  if (width < 992) return 'tablet';

  // 根据用户代理字符串判断
  const isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(ua);
  const isTablet = /iPad|Android(?!.*Mobile)|Tablet|Silk/i.test(ua);

  if (isMobile) return 'mobile';
  if (isTablet) return 'tablet';

  return 'desktop';
}

Vue.prototype.$Message = Message;
Vue.use(ElementUI);
Vue.config.productionTip = false;

import "@/assets/css/public.css";

function isMobileDevice() {
  return window.innerWidth < 576 ||
    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

function isWeChatEnv() {
  return /MicroMessenger|miniProgram/i.test(navigator.userAgent);
}

function isAdminRoute() {
  const path = window.location.pathname || '';
  return /^\/(newCompany|Home|setting|manage|employees|checkAccount|report|bills|agreementPrice|manageCorpInfo|data|reimbursement)/.test(path);
}

function isIOS() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

function isEmbedMode() {
  if (window.self !== window.top) {
    return true;
  }
  try {
    if (sessionStorage.getItem('embedMode') === '1') {
      return true;
    }
  } catch (e) {}
  const qs = (window.location.search || '') + (window.location.hash || '');
  return /[?&]embed=1(?:&|$)/.test(qs);
}

function shouldApplyEmbedMobileGuard() {
  if (!isMobileDevice()) {
    return false;
  }
  return isEmbedMode() || isWeChatEnv() || isAdminRoute();
}

const EMBED_MOBILE_VIEWPORT =
  'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover';

function lockViewportScale() {
  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) {
    return;
  }
  meta.setAttribute('content', EMBED_MOBILE_VIEWPORT);
}

function forceInputFontSize(target) {
  if (!target || !target.style) {
    return;
  }
  target.style.fontSize = '16px';
  target.style.webkitTextSizeAdjust = '100%';
}

function setupIOSInputZoomGuard() {
  if (!isIOS() || !document.documentElement.classList.contains('embed-mobile')) {
    return;
  }

  document.addEventListener('touchstart', (e) => {
    const target = e.target;
    if (!target) {
      return;
    }
    const tag = target.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') {
      forceInputFontSize(target);
    } else if (target.closest && target.closest('.el-input, .el-textarea')) {
      const input = target.closest('.el-input, .el-textarea').querySelector('input, textarea');
      if (input) {
        forceInputFontSize(input);
      }
    }
  }, true);

  document.addEventListener('focusin', (e) => {
    const target = e.target;
    if (!target) {
      return;
    }
    const tag = target.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') {
      forceInputFontSize(target);
      lockViewportScale();
    }
  }, true);
}

function watchDynamicInputs() {
  if (!document.documentElement.classList.contains('embed-mobile')) {
    return;
  }

  const applyToNode = (node) => {
    if (!node || node.nodeType !== 1) {
      return;
    }
    if (node.matches && node.matches('input, textarea, select')) {
      forceInputFontSize(node);
    }
    if (node.querySelectorAll) {
      node.querySelectorAll('input, textarea, select').forEach(forceInputFontSize);
    }
  };

  document.querySelectorAll('input, textarea, select').forEach(forceInputFontSize);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(applyToNode);
    });
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function resetEmbedMobileLayout() {
  if (!document.documentElement.classList.contains('embed-mobile')) {
    return;
  }

  lockViewportScale();

  window.scrollTo(0, 0);
  document.documentElement.scrollLeft = 0;
  document.body.scrollLeft = 0;
  document.body.style.overflow = '';
  document.body.style.overflowX = 'hidden';
  document.body.style.paddingRight = '';
  document.body.style.width = '';
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
}

function setupEmbedMobileDialogGuard() {
  if (!document.documentElement.classList.contains('embed-mobile')) {
    return;
  }

  document.addEventListener('focusout', () => {
    setTimeout(resetEmbedMobileLayout, 100);
  }, true);

  const observer = new MutationObserver(() => {
    if (!document.body.classList.contains('el-popup-parent--hidden')) {
      setTimeout(resetEmbedMobileLayout, 100);
    }
  });
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class', 'style']
  });
}

function applyEmbedMobileGuard() {
  if (!shouldApplyEmbedMobileGuard()) {
    return;
  }

  try {
    sessionStorage.setItem('embedMode', '1');
  } catch (e) {}

  document.documentElement.classList.add('embed-mobile');
  lockViewportScale();
  setupIOSInputZoomGuard();
  setupEmbedMobileDialogGuard();

  if (document.body) {
    watchDynamicInputs();
  } else {
    document.addEventListener('DOMContentLoaded', watchDynamicInputs);
  }
}

applyEmbedMobileGuard();

(async () => {
  await handleAutoLogin();
  new Vue({
    el: '#app',
    router,
    components: {
      App
    },
    template: '<App/>'
  });
})();



// WEBPACK FOOTER //
// ./src/main.js